import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { getTheme2SearchFilterFieldCss } from "utils/theme2MultiSelect";
import { getStickyStockTableStickyColumnCss } from "utils/reactTableTheme";

const SEARCH_CHANNELS_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-channels.search-channels--theme2 .search-channels-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-channels.search-channels--theme2",
    filtersSelector: ".search-channels-table-card .search-channels-filters",
    rowClass: "search-channels-filters-row",
    colClass: "search-channels-filter-col",
  })}
  .search-channels.search-channels--theme2 .search-channels-filters-row {
    column-gap: 4px;
  }
  .search-channels.search-channels--theme2 .search-channels-filter-col {
    padding-left: 4px;
    padding-right: 4px;
  }
  .search-channels.search-channels--theme2 .search-channels-filter-col:first-child {
    padding-left: 0;
  }
  ` : ""}
  .search-channels-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-channels-card-header h2,
  .search-channels-card-header h4 {
    font-size: 16px !important;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-channels .align-items-center {
    margin-top: 3px;
  }
  .search-channels:not(.search-channels--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .search-channels.search-channels--theme2 .card .card-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 15px;
    padding-right: 15px;
  }
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) > * {
    max-width: 100%;
    min-width: 0;
  }
  ${getStickyStockTableStickyColumnCss()}
`;

const ChannelsCards = ({ isTheme2, filters, table, tableHeader, headerActions }) => {
  const { t } = useTranslation();

  const titleHeader = (
    <CardHeader className="search-channels-card-header">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="mb-0">{t("channels.title")}</h2>
        {headerActions}
      </div>
    </CardHeader>
  );

  return (
    <>
      <style>{SEARCH_CHANNELS_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-channels-table-card">
          {titleHeader}
          <CardBody>
            <div className="search-channels-filters">{filters}</div>
            {table}
          </CardBody>
        </Card>
      ) : (
        <>
          <Card>
            {titleHeader}
            <CardBody>{filters}</CardBody>
          </Card>
          <Card className="mt-2">
            {tableHeader ? <CardHeader>{tableHeader}</CardHeader> : null}
            <CardBody>{table}</CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default ChannelsCards;
